import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/pages/dashboard/components/DashboardLayout';
import ApartmentForm from '@/pages/dashboard/apartments/components/ApartmentForm';
import { useAuth } from '@/context/AuthContext';
import { supabase } from '@/lib/supabase';

function ApartmentNew() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [businessId, setBusinessId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!user) return;
      const { data } = await supabase
        .from('businesses')
        .select('id')
        .eq('owner_id', user.id)
        .maybeSingle();
      if (mounted) {
        setBusinessId(data?.id ?? null);
        setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [user]);

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center py-20">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10">
            <i className="ri-loader-4-line text-2xl text-primary-400 animate-spin" />
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">Publier un bien</h1>
        <p className="text-sm text-foreground-400 mt-1">
          Renseignez les informations de votre appartement, terrain ou bureau.
        </p>
      </div>

      <div className="max-w-3xl">
        <ApartmentForm
          businessId={businessId}
          ownerId={user!.id}
          onSaved={() => navigate('/dashboard/apartments')}
        />
      </div>
    </DashboardLayout>
  );
}

export default ApartmentNew;